import React from "react";
import { Clock } from "lucide-react";

interface ScreenshotCardProps {
  title: string;
  timestamp?: string;
  description?: string;
  imageUrl?: string;
  type?: "green" | "orange" | "red";
}

const ScreenshotCard: React.FC<ScreenshotCardProps> = ({
  title,
  timestamp,
  description,
  imageUrl,
  type = "red",
}) => {
  // Map type to text color class
  const textColorMap = {
    green: "text-green-600",
    orange: "text-orange-500",
    red: "text-red-600",
  };

  const textColorClass = textColorMap[type] || "text-gray-600";

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-br from-blue-100 to-purple-100 flex items-center justify-center">
        {imageUrl ? (
          <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-blue-200 to-indigo-300"></div>
        )}
      </div>
      <div className="p-2">
        <h3 className="font-medium text-sm text-gray-900">{title}</h3>
        {description && <p className={`text-xs ${textColorClass} mb-2`}>{description}</p>}
        {timestamp && (
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center space-x-1 text-xs text-gray-500">
              <Clock className="w-3 h-3" />
              <span>{timestamp}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScreenshotCard;
